import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DashboardsRoutingModule} from './dashboards-routing.module';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DashboardFiltersComponent} from './dashboard-filters/dashboard-filters.component';
import {DashboardFramelessComponent} from './dashboard-frameless/dashboard-frameless.component';
import {DateRangePickerModule} from '@syncfusion/ej2-angular-calendars';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    DashboardComponent,
    DashboardFiltersComponent,
    DashboardFramelessComponent
  ],
  imports: [
    CommonModule,
    DashboardsRoutingModule,
    DateRangePickerModule,
    NgbModule,
  ]
})
export class DashboardsModule { }
